import { render, staticRenderFns } from "./base-accordion-toggler.vue?vue&type=template&id=1749682e&scoped=true&"
import script from "./base-accordion-toggler.vue?vue&type=script&lang=js&"
export * from "./base-accordion-toggler.vue?vue&type=script&lang=js&"
import style0 from "./base-accordion-toggler.vue?vue&type=style&index=0&id=1749682e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749682e",
  null
  
)

export default component.exports